import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const SquareArrowLeftContainer = styled.div<React.CSSProperties>`
  background: rgba(0, 0, 0, 0.8);
  border-radius: ${Screen.widthRatio * 20}px;
  height: ${Screen.widthRatio * 110}px;
  left: ${Screen.widthRatio * 2}px;
  line-height: ${Screen.widthRatio * 150}px;
  opacity: 0;
  padding-left: ${Screen.widthRatio * 19}px;
  position: absolute;
  margin-top: ${2 * Screen.widthRatio}px;
  width: ${Screen.widthRatio * 49}px;
  &:hover {
    opacity: 1;
  }
  & > svg {
    position: absolute;
    top: ${Screen.widthRatio * 40}px;
  }
`;

export default withAnimation(SquareArrowLeftContainer);
